import { createSlice } from '@reduxjs/toolkit';
import { isBannedChat, isEnableBanAll } from './functions';
import ReducerRegistry from '../base/redux/ReducerRegistry';
import { getParticipantById, isParticipantModerator } from '../base/participants/functions';
import { getConferenceState } from '../base/conference/functions';
const initialState = {
    enabled: false,
    whitelist: {},
    blacklist: {},
    canChat: undefined,
    actor: null,
    recentSenders: {}
};
// Action creators
export const approveParticipantChat = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (participant && conference) {
        const isBanned = isBannedChat(participant, state);
        if (isBanned) {
            conference.vtChatModerationApprove(id);
        }
    }
};
export const rejectParticipantChat = (id) => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const participant = getParticipantById(state, id);
    if (participant && conference) {
        const isBanned = isBannedChat(participant, state);
        const isModerator = isParticipantModerator(participant);
        if (!isBanned && !isModerator) {
            conference.vtChatModerationReject(id);
        }
    }
};
export const enableBanAllChat = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAll(state);
    if (!isBanAll && conference) {
        conference.enableVTChatModeration();
    }
};
export const disableBanAllChat = () => (dispatch, getState) => {
    const state = getState();
    const { conference } = getConferenceState(state);
    const isBanAll = isEnableBanAll(state);
    if (isBanAll && conference) {
        conference.disableVTChatModeration();
    }
};
// Reducer slice
const vtChatModeration = createSlice({
    name: 'features/vt-chat-moderation',
    initialState,
    reducers: {
        addRecentSender: (state, action) => {
            const sender = action.payload;
            state.recentSenders[sender.senderAccId] = sender;
        },
        setRecentSenders: (state, action) => {
            state.recentSenders = action.payload;
        },
        disableVTChatModeration: (state, action) => {
            if (state.enabled) {
                state.enabled = false;
                state.actor = action.payload;
                state.canChat = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        enableVTChatModeration: (state, action) => {
            if (!state.enabled) {
                state.enabled = true;
                state.actor = action.payload;
                state.canChat = undefined;
                state.whitelist = {};
                state.blacklist = {};
            }
        },
        localParticipantApproved: (state) => {
            state.canChat = true;
        },
        localParticipantRejected: (state) => {
            state.canChat = false;
        },
        participantApproved: (state, action) => {
            if (state.enabled) {
                state.whitelist[action.payload.jid] = true;
            }
            else {
                state.blacklist[action.payload.jid] = false;
            }
        },
        participantRejected: (state, action) => {
            if (state.enabled) {
                state.whitelist[action.payload.jid] = false;
            }
            else {
                state.blacklist[action.payload.jid] = true;
            }
        }
    }
});
// Registering the reducer
ReducerRegistry.register('features/vt-chat-moderation', vtChatModeration.reducer);
// Exporting actions and reducer
export const { disableVTChatModeration, enableVTChatModeration, localParticipantApproved, localParticipantRejected, participantApproved, participantRejected, addRecentSender, setRecentSenders } = vtChatModeration.actions;
export default vtChatModeration.reducer;
